import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Divider, Tag } from 'antd';
import { CheckCircleOutlined, SafetyCertificateOutlined, TeamOutlined } from '@ant-design/icons';
import { companyAPI } from '../services/api';
import './About.css';

function About() {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  const loadCompanyInfo = async () => {
    try {
      const res = await companyAPI.getInfo();
      setCompanyInfo(res.data);
    } catch (error) {
      console.error('加载公司信息失败');
    }
  };

  if (!companyInfo) {
    return <div className="loading-container">加载中...</div>;
  }

  return (
    <div className="about-container">
      <div className="about-header">
        <h1 className="page-title">关于我们</h1>
        <p className="page-subtitle">{companyInfo.name}</p>
      </div>

      <Card className="about-card">
        <div className="company-intro">
          <h2><TeamOutlined /> 公司介绍</h2>
          <p className="intro-text">{companyInfo.description}</p>

          <Row gutter={[24, 24]} style={{ marginTop: 32 }}>
            <Col xs={24} sm={12} md={8}>
              <div className="info-item">
                <div className="info-label">业务定位</div>
                <div className="info-value">AI情绪管理与企业心理健康服务</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div className="info-item">
                <div className="info-label">核心能力</div>
                <div className="info-value">AI情绪识别 / 专业心理团队 / EAP项目运营</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <div className="info-item">
                <div className="info-label">服务覆盖</div>
                <div className="info-value">个人用户与全国企事业单位</div>
              </div>
            </Col>
          </Row>
        </div>

        <Divider />

        <div className="services-section">
          <h2><CheckCircleOutlined /> 服务内容</h2>

          <Row gutter={[32, 32]}>
            <Col xs={24} md={12}>
              <Card type="inner" title="个人服务 (B2C)" className="service-card">
                <ul className="service-list">
                  {companyInfo.services.personal.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
                <div className="service-stats">
                  <Tag color="blue">服务用户: {companyInfo.stats.users}</Tag>
                </div>
              </Card>
            </Col>

            <Col xs={24} md={12}>
              <Card type="inner" title="企业服务 (B2B)" className="service-card">
                <ul className="service-list">
                  {companyInfo.services.enterprise.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
                <div className="service-stats">
                  <Tag color="green">合作企业: {companyInfo.stats.enterprises}</Tag>
                </div>
              </Card>
            </Col>
          </Row>
        </div>

        <Divider />

        <div className="credentials-section">
          <h2><SafetyCertificateOutlined /> 资质与认证</h2>
          <div className="credentials-grid">
            <div className="credential-item">
              <div className="credential-label">心理学院校合作</div>
              <div className="credential-desc">与知名心理学院校建立合作关系</div>
            </div>
            <div className="credential-item">
              <div className="credential-label">认证咨询师团队</div>
              <div className="credential-desc">{companyInfo.stats.consultants} 专业心理咨询师</div>
            </div>
            <div className="credential-item">
              <div className="credential-label">用户满意度</div>
              <div className="credential-desc">{companyInfo.stats.satisfaction} 用户好评率</div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}

export default About;
